import {GOOGLE_IDS} from './googleAuthId';
import {SIZES} from './sizes';
import {WEEK_DAYS} from './constants';
import {CALENDAR} from './calendarConstants';
import {PROFILE} from './profileViewNames';
import {INPUT_CONFIG} from './webInputConfig';
import {TEXTFIELD_TYPES} from './textFieldTypes';

const DEFAULT_ANIMATED_DURATION = 250;

export default {
  GOOGLE_IDS,
  SIZES,
  DEFAULT_ANIMATED_DURATION,
  WEEK_DAYS,
  CALENDAR,
  MINUTES_IN_HOUR: 60,
  MILIS_IN_MINUTE: 60000,
  PROFILE,
  INPUT_CONFIG,
  TEXTFIELD_TYPES,
  OPENVIDU_SERVER: 'uclass-openvidu-dev.nixdev.co'
};
